module.exports = __webpack_public_path__ + "img/left-arrow.3fa9c668.png";